<template>
  <div class="home"></div>
</template>

<script>
import { hasApolloToken } from '@/vue-apollo'
import { Capacitor } from '@capacitor/core'

export default {
  async created () {
    const authorized = await hasApolloToken()
    if (authorized && !Capacitor.isNativePlatform()) {
      await this.$router.push({
        name: 'dashboard'
      })
    } else {
      await this.$router.push({
        name: 'auth_login'
      })
    }
  }
}
</script>

<style lang="scss">
.home {
  max-width: 70rem;
  margin: 10rem auto;

  background-color: $color-blue-lighten;
}
</style>
